var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-hidden"},[_c('div',{staticClass:"px-4 py-5 sm:px-6 items-baseline flex justify-between"},[_c('h3',{staticClass:"text-lg leading-6 font-medium text-gray-900"},[_vm._t("header")],2),_vm._v(" "),_c('div',[_vm._t("action")],2)]),_vm._v(" "),_c('div',{},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }